import { registerSem } from '../registry';

// Map document.added to a timeline entity we can consume in pages
registerSem('document.added', ({ ev, now, convId }) => {
  const d = (ev.data || {}) as any;
  const docId: string | undefined = d.doc_id || d.docId;
  const title: string | undefined = d.title || d.name;
  if (!docId || !title) return null;
  const id = `doc-suggestion-${docId}`;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id,
      kind: 'doc_suggestion',
      timestamp: now,
      props: (() => {
        const p: any = { doc_id: docId, title };
        if (typeof d.url === 'string' && d.url.trim() !== '') p.url = d.url;
        if (typeof d.mime_type === 'string' && d.mime_type.trim() !== '') p.mime_type = d.mime_type;
        if (typeof d.relevance_score === 'number') p.relevance_score = d.relevance_score;
        if (typeof d.reason === 'string' && d.reason.trim() !== '') p.reason = d.reason;
        if (typeof d.modified_time === 'string' && d.modified_time.trim() !== '')
          p.modified_time = d.modified_time;
        return p as any;
      })(),
    },
  };
});

// Map document.removed to a simple removal entity
registerSem('document.removed', ({ ev, now, convId }) => {
  const d = (ev.data || {}) as any;
  const docId: string | undefined = d.doc_id || d.docId;
  if (!docId) return null;
  const id = `doc-suggestion-removed-${docId}`;
  return {
    kind: 'add',
    convId,
    entity: {
      id,
      kind: 'doc_suggestion_removed',
      timestamp: now,
      props: {
        doc_id: docId,
        reason: typeof d.reason === 'string' ? d.reason : undefined,
      },
    },
  };
});

// Map document.failed to a status entity for user feedback
registerSem('document.failed', ({ ev, now, convId }) => {
  const d = (ev.data || {}) as any;
  const text = `Could not add ${d?.title || d?.doc_id || 'document'}: ${d?.reason || 'validation error'}`;
  return {
    kind: 'add',
    convId,
    entity: {
      id: `document-failed-${ev.id}`,
      kind: 'status',
      timestamp: now,
      props: {
        type: 'error',
        text,
        error_code: d?.error_code,
        doc_id: d?.doc_id,
        title: d?.title,
      },
    },
  };
});
